export default __webpack_public_path__ + "static/media/1165.10f95d30.png";